

var curTextBanner = -1;

function RotateTextBanner() {

    var totalTextBanner = $(".TextBannercontainer .TxtSliderItem").length;

    if (curTextBanner == -1) {

        curTextBanner = $(".TextBannercontainer .TxtSliderItem.active").index();
    }

     
    $(".TextBannercontainer .TxtSliderItem").removeClass("active").hide();

    $curspan = $(".TextBannercontainer .TxtSliderItem").eq(curTextBanner);

    //console.log(curTextBanner);

    $curspan.hide();
    $curspan.fadeIn("slow");

    $curspan.addClass("active");

    if (curTextBanner < totalTextBanner - 1) {
        curTextBanner++;
    }
    else {
        curTextBanner = 0;
    }



}
 
$(document).ready(function () {

    if ($("div.TextBannercontainer").length > 0 && $("div.TextBannercontainer .TxtSliderItem").length > 0) {

       
        RotateTextBanner();

        //console.log("item adedi:"+$("div.TextBannercontainer span").length);

        if ($("div.TextBannercontainer .TxtSliderItem").length > 1)
        { 
            setInterval('RotateTextBanner()', 3500);
        }

       // $("#MainMenu").addClass("HasTextBanner");
    }

});